import React from 'react';
import { Box, Divider, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  inLine: {
    display: 'flex',
    flexDirection: 'row'
  },
  coverages: {
    borderRadius: theme.spacing(1)
  }
}));

export default function TabContentSkeleton() {
  const classes = useStyles();

  const getCustomerDetail = () => {
    return (
      <>
        <Grid item xs={3}>
          <Skeleton variant="text" width={120} height={40} />
          <Skeleton variant="text" width={80} height={30} />
        </Grid>
        <Grid item xs={3}>
          <Skeleton variant="text" width={140} height={40} />
          <Skeleton variant="text" width={120} height={25} />
          <Skeleton variant="text" width={100} height={25} />
        </Grid>
        <Grid item xs={3}>
          <Skeleton variant="text" width={120} height={40} />
          <Skeleton variant="text" width={60} height={30} />
        </Grid>
        <Grid item xs={3}>
          <Skeleton variant="text" width={150} height={40} />
          <Skeleton variant="text" width={60} height={30} />
        </Grid>
        <Grid item xs={3}>
          <Skeleton variant="text" width={80} height={40} />
          <Skeleton variant="text" width={90} height={30} />
        </Grid>
        <Grid item xs={3}>
          <Skeleton variant="text" width={120} height={40} />
          <Skeleton variant="text" width={90} height={30} />
        </Grid>
        <Grid item xs={3}>
          <Skeleton variant="text" width={70} height={40} />
          <Skeleton variant="text" width={90} height={30} />
        </Grid>
        <Grid item xs={3}>
          <Skeleton variant="text" width={160} height={40} />
          <Skeleton variant="text" width={50} height={30} />
        </Grid>
      </>
    );
  };

  return (
    <Box component="section" p={3}>
      <Grid container spacing={3} className={classes.content}>
        <Grid item xs={3}>
          <Skeleton variant="text" width={130} height={40} />
          <Skeleton variant="text" width={120} height={30} />
        </Grid>
        <Grid item xs={3}>
          <Skeleton variant="text" width={140} height={40} />
          <Skeleton variant="text" width={80} height={30} />
        </Grid>
        <Grid item xs={3}>
          <Skeleton variant="text" width={140} height={40} />
          <Skeleton variant="text" width={80} height={30} />
        </Grid>
        <Grid item xs={3}>
          <Skeleton variant="text" width={140} height={40} />
          <Skeleton variant="text" width={80} height={30} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" width={140} height={30} />
          <Divider />
        </Grid>
        {getCustomerDetail()}
      </Grid>
      <Box mt={8}>
        <Skeleton
          className={classes.coverages}
          variant="rect"
          width="100%"
          height={50}
        />
      </Box>
      <Box mt={3}>
        <Skeleton
          className={classes.coverages}
          variant="rect"
          width="100%"
          height={40}
        />
      </Box>
    </Box>
  )
}
